import { ModelFactory } from '@shared/factories/model.factory';
import { SupportedCountryType } from '@generated/graphql';
import { SupportedCountry } from '@modules/supported-country/models/supported-country.model';

export class SupportedCountryFactory extends ModelFactory<SupportedCountryType, SupportedCountry> {
  create (state: SupportedCountryType): SupportedCountry {
    return new SupportedCountry(state);
  }
}

export const supportedCountryFactory = new SupportedCountryFactory();
